import { biometricConstants } from '../constants'

export const BioResult = (state = {}, action) => {
  switch (action.type) {
    case biometricConstants.BIO_RESULT_REQUEST:
    return { loading: true, items: undefined, error: undefined }
      
    case biometricConstants.BIO_RESULT_SUCCESS:
    return { loading: false, items: action.bioResult.Body, error: undefined}
      
    case biometricConstants.BIO_RESULT_FAILURE:
    return { loading: false, items: undefined, error: action.error}
      
    default:
      return state
  }
}
